import { cn } from '@/lib/cn';

export function Container({
  children,
  className,
  as: As = 'div',
}: {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
}) {
  return <As className={cn('mx-auto w-full max-w-site px-4 sm:px-6 lg:px-8', className)}>{children}</As>;
}
